var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
var CaseOverview = /** @class */ (function (_super) {
    __extends(CaseOverview, _super);
    function CaseOverview() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CaseOverview.prototype, "dataList", {
        get: function () {
            var _this = this;
            return Object.values(this.data).filter(function (item) { return !item.hidden.includes(_this.menuType); });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop()
    ], CaseOverview.prototype, "data", void 0);
    __decorate([
        Prop()
    ], CaseOverview.prototype, "menuType", void 0);
    CaseOverview = __decorate([
        Component({
            components: {}
        })
    ], CaseOverview);
    return CaseOverview;
}(Vue));
export default CaseOverview;
